const AlertIcon = ({ className }: { className?: string }) => (
	<svg
		class={className}
		fill='none'
		height='55'
		viewBox='0 0 62 55'
		width='62'
		xmlns='http://www.w3.org/2000/svg'
	>
		<path
			d='M33.6667 41.6667C33.6667 43.1394 32.4728 44.3333 31 44.3333C29.5272 44.3333 28.3333 43.1394 28.3333 41.6667C28.3333 40.1939 29.5272 39 31 39C32.4728 39 33.6667 40.1939 33.6667 41.6667Z'
			fill='currentColor'
		/>
		<path
			d='M33 19.6667C33 18.5621 32.1046 17.6667 31 17.6667C29.8954 17.6667 29 18.5621 29 19.6667V31.6667C29 32.7712 29.8954 33.6667 31 33.6667C32.1046 33.6667 33 32.7712 33 31.6667V19.6667Z'
			fill='currentColor'
		/>
		<path
			clip-rule='evenodd'
			d='M25.229 3.65079C27.796 -0.788098 34.2041 -0.788096 36.7712 3.65079L60.6815 44.9958C63.2518 49.4402 60.0446 54.9999 54.9104 54.9999H7.08972C1.95557 54.9999 -1.25166 49.4402 1.31862 44.9958L25.229 3.65079ZM33.3085 5.65329C32.2817 3.87774 29.7185 3.87774 28.6916 5.65329L4.78128 46.9983C3.75316 48.7761 5.03606 50.9999 7.08972 50.9999H54.9104C56.9641 50.9999 58.247 48.7761 57.2189 46.9983L33.3085 5.65329Z'
			fill='currentColor'
			fill-rule='evenodd'
		/>
	</svg>
)

export { AlertIcon }
